"use strict";

// =====================================================
// HORAS EXTRAS Y DOBLES
//
// Archivo:
// src/fronend/Ingresos/dobles.js
// =====================================================


// =====================================================
// VARIABLES
// =====================================================

let registrosDobles = [];

let moduloInicializado = false;

let guardandoDobles = false;


// =====================================================
// INICIALIZAR MÓDULO
// =====================================================

export function inicializarDobles() {

    if (moduloInicializado) {

        console.log(
            "⚠️ Módulo HORAS EXTRAS Y DOBLES ya fue inicializado."
        );

        return;

    }


    moduloInicializado = true;


    console.log(
        "✅ Inicializando módulo HORAS EXTRAS Y DOBLES..."
    );


    // =================================================
    // CARGAR TABLA
    // =================================================

    cargarTablaDobles();


    // =================================================
    // CONFIGURAR EVENTOS
    // =================================================

    configurarEventos();

}


// =====================================================
// CONFIGURAR EVENTOS
// =====================================================

function configurarEventos() {


    // =================================================
    // BUSCADOR
    // =================================================

    const buscarHoraExtra =
        document.getElementById(
            "buscarHoraExtra"
        );


    if (buscarHoraExtra) {

        buscarHoraExtra.addEventListener(
            "input",
            function () {

                renderizarTablaDobles(
                    this.value
                );

            }
        );

    }


    // =================================================
    // LIMPIAR BÚSQUEDA
    // =================================================

    const btnLimpiarBusqueda =
        document.getElementById(
            "btnLimpiarBusqueda"
        );


    if (btnLimpiarBusqueda) {

        btnLimpiarBusqueda.addEventListener(
            "click",
            function () {

                if (buscarHoraExtra) {

                    buscarHoraExtra.value = "";

                }


                renderizarTablaDobles();

            }
        );

    }


    // =================================================
    // BOTONES EDITAR
    // =================================================

    document.addEventListener(
        "click",
        manejarClickEditar
    );


    // =================================================
    // BOTÓN GUARDAR DOBLES
    //
    // Se aceptan estos IDs:
    //
    // #btnGuardarDobles
    // #guardarDobles
    // #btnGuardar
    //
    // =================================================

    document.addEventListener(
        "click",
        function (event) {

            const boton =
                event.target.closest(
                    "#btnGuardarDobles, #guardarDobles, #btnGuardar"
                );


            if (!boton) {

                return;

            }


            event.preventDefault();


            guardarDobles();

        }
    );


    // =================================================
    // CAMBIO DE HORAS DOBLES
    // =================================================

    document.addEventListener(
        "input",
        function (event) {

            if (
                event.target &&
                event.target.id === "hrsDobles"
            ) {

                calcularDoblesAutomaticamente();

            }

        }
    );


    // =================================================
    // CAMBIO DE PAGO HORA EXTRA
    // =================================================

    document.addEventListener(
        "input",
        function (event) {

            if (
                event.target &&
                (
                    event.target.id === "pagoExtra" ||
                    event.target.id === "hrsDobles"
                )
            ) {

                calcularDoblesAutomaticamente();

            }

        }
    );

}


// =====================================================
// CARGAR TABLA
// =====================================================

async function cargarTablaDobles() {

    const tbodyDobles =
        document.getElementById(
            "tbodyDobles"
        );


    if (!tbodyDobles) {

        console.error(
            "❌ No se encontró #tbodyDobles."
        );

        return;

    }


    // =================================================
    // MENSAJE DE CARGA
    // =================================================

    tbodyDobles.innerHTML = `

        <tr>

            <td
                colspan="14"
                class="loading"
            >

                <div
                    class="spinner-border text-success me-2"
                    role="status"
                >

                    <span class="visually-hidden">
                        Cargando...
                    </span>

                </div>

                Cargando horas extras y dobles...

            </td>

        </tr>

    `;


    try {

        // =================================================
        // CONSULTAR RUTA
        // =================================================

        const respuesta =
            await fetch(
                "/dobles/listar",
                {
                    method: "GET",

                    headers: {
                        "Accept":
                            "application/json"
                    }
                }
            );


        // =================================================
        // VALIDAR HTTP
        // =================================================

        if (!respuesta.ok) {

            throw new Error(
                `HTTP ${respuesta.status} - ${respuesta.statusText}`
            );

        }


        // =================================================
        // CONVERTIR JSON
        // =================================================

        const resultado =
            await respuesta.json();


        console.log(
            "📥 Respuesta recibida de /dobles/listar:",
            resultado
        );


        // =================================================
        // VALIDAR RESULTADO
        // =================================================

        if (
            !resultado ||
            resultado.ok !== true
        ) {

            throw new Error(
                resultado?.mensaje ||
                "No se pudieron cargar los datos."
            );

        }


        // =================================================
        // GUARDAR DATOS
        // =================================================

        registrosDobles =
            Array.isArray(
                resultado.data
            )
                ? resultado.data
                : [];


        console.log(
            "✅ Registros cargados:",
            registrosDobles.length
        );


        // =================================================
        // MOSTRAR PRIMER REGISTRO
        // =================================================

        if (
            registrosDobles.length > 0
        ) {

            console.log(
                "📦 Primer registro:",
                registrosDobles[0]
            );

        }


        // =================================================
        // RENDERIZAR
        // =================================================

        renderizarTablaDobles();


    } catch (error) {

        console.error(
            "❌ Error al cargar horas extras y dobles:",
            error
        );


        tbodyDobles.innerHTML = `

            <tr>

                <td
                    colspan="14"
                    class="text-center text-danger py-4"
                >

                    <i
                        class="bi bi-exclamation-triangle-fill"
                    ></i>

                    <div class="mt-2">

                        Error al cargar las horas
                        extras y dobles.

                    </div>

                    <small>

                        ${escapeHtml(
                            error.message
                        )}

                    </small>

                </td>

            </tr>

        `;

    }

}


// =====================================================
// RENDERIZAR TABLA
// =====================================================

function renderizarTablaDobles(
    textoBusqueda = ""
) {

    const tbodyDobles =
        document.getElementById(
            "tbodyDobles"
        );


    if (!tbodyDobles) {

        console.error(
            "❌ No se encontró #tbodyDobles."
        );

        return;

    }


    // =================================================
    // TEXTO DE BÚSQUEDA
    // =================================================

    const texto =
        String(
            textoBusqueda ?? ""
        )
        .toLowerCase()
        .trim();


    // =================================================
    // FILTRAR REGISTROS
    // =================================================

    const registrosFiltrados =
        registrosDobles.filter(
            function (registro) {

                if (!texto) {

                    return true;

                }


                const idIngreso =
                    String(
                        registro.IDINGRESONO ?? ""
                    )
                    .toLowerCase();


                const nombre =
                    String(
                        registro.NOMBREEMPLEADO ?? ""
                    )
                    .toLowerCase();


                const dpi =
                    String(
                        registro.DPI ?? ""
                    )
                    .toLowerCase();


                const puesto =
                    String(
                        registro.NOMBREPUESTO ??
                        registro.PUESTO ??
                        ""
                    )
                    .toLowerCase();


                const direccion =
                    String(
                        registro.DIRECCION ?? ""
                    )
                    .toLowerCase();


                return (

                    idIngreso.includes(texto)

                    ||

                    nombre.includes(texto)

                    ||

                    dpi.includes(texto)

                    ||

                    puesto.includes(texto)

                    ||

                    direccion.includes(texto)

                );

            }
        );


    // =================================================
    // SIN REGISTROS
    // =================================================

    if (
        registrosFiltrados.length === 0
    ) {

        tbodyDobles.innerHTML = `

            <tr>

                <td
                    colspan="14"
                    class="empty-state"
                >

                    <i
                        class="bi bi-inbox"
                    ></i>

                    <div>

                        No hay registros para mostrar.

                    </div>

                </td>

            </tr>

        `;


        actualizarResumen(
            []
        );


        return;

    }


    // =================================================
    // CONSTRUIR TABLA
    // =================================================

    tbodyDobles.innerHTML =
        registrosFiltrados
            .map(
                function (registro) {


                    const idIngreso =
                        registro.IDINGRESONO ??
                        "";


                    const nombreEmpleado =
                        registro.NOMBREEMPLEADO ??
                        "";


                    const dpi =
                        registro.DPI ??
                        "";


                    const puesto =
                        registro.NOMBREPUESTO ??
                        registro.PUESTO ??
                        "";


                    const salarioBase =
                        convertirNumero(
                            registro.SALARIOBASE
                        );


                    const horasExtras =
                        convertirNumero(
                            registro.HORASEXTRAS
                        );


                    const pagoExtra =
                        convertirNumero(
                            registro.PAGOEXTRA
                        );


                    const totalExtra =
                        convertirNumero(
                            registro.TOTALEXTRAPAGADO
                        );


                    const horasDobles =
                        convertirNumero(
                            registro.HRSDOBLES
                        );


                    const pagoHoraDoble =
                        convertirNumero(
                            registro.PAGOHRSDOBLE
                        );


                    const totalDobles =
                        convertirNumero(
                            registro.TOTALHRSDOBLES ??
                            registro.TOTALHORASDOBLES
                        );


                    const totalExtrasDobles =
                        convertirNumero(
                            registro.TOTALEXTRASYDOBLES ??
                            registro.TOTALEXTRASDOBLES
                        );


                    const estado =
                        registro.ESTADO ??
                        "";


                    const iniciales =
                        obtenerIniciales(
                            nombreEmpleado
                        );


                    return `

                        <tr>

                            <td
                                class="text-center fw-semibold"
                            >

                                ${escapeHtml(
                                    idIngreso
                                )}

                            </td>


                            <td>

                                <div
                                    class="d-flex align-items-center"
                                >

                                    <span
                                        class="employee-avatar"
                                    >

                                        ${escapeHtml(
                                            iniciales
                                        )}

                                    </span>

                                    <span
                                        class="employee-name"
                                    >

                                        ${escapeHtml(
                                            nombreEmpleado
                                        )}

                                    </span>

                                </div>

                            </td>


                            <td>

                                ${escapeHtml(
                                    dpi
                                )}

                            </td>


                            <td>

                                ${escapeHtml(
                                    puesto
                                )}

                            </td>


                            <td
                                class="text-end salary"
                            >

                                Q ${formatearNumero(
                                    salarioBase
                                )}

                            </td>


                            <td
                                class="text-center"
                            >

                                <span
                                    class="hours-badge"
                                >

                                    ${formatearNumero(
                                        horasExtras
                                    )}

                                </span>

                            </td>


                            <td
                                class="text-end money"
                            >

                                Q ${formatearNumero(
                                    pagoExtra
                                )}

                            </td>


                            <td
                                class="text-end money-total"
                            >

                                Q ${formatearNumero(
                                    totalExtra
                                )}

                            </td>


                            <td
                                class="text-center"
                            >

                                <span
                                    class="hours-double"
                                >

                                    ${formatearNumero(
                                        horasDobles
                                    )}

                                </span>

                            </td>


                            <td
                                class="text-end money"
                            >

                                Q ${formatearNumero(
                                    pagoHoraDoble
                                )}

                            </td>


                            <td
                                class="text-end money-total"
                            >

                                Q ${formatearNumero(
                                    totalDobles
                                )}

                            </td>


                            <td
                                class="text-end money-total"
                            >

                                Q ${formatearNumero(
                                    totalExtrasDobles
                                )}

                            </td>


                            <td
                                class="text-center"
                            >

                                ${obtenerEstado(
                                    estado
                                )}

                            </td>


                            <td
                                class="text-center"
                            >

                                <button
                                    type="button"
                                    class="btn btn-sm btn-outline-success btn-tabla btnEditarDobles"
                                    data-id="${escapeHtml(
                                        idIngreso
                                    )}"
                                    title="Editar"
                                >

                                    <i
                                     class="bi bi-cash-coin"
                                    ></i>

                                </button>

                            </td>

                        </tr>

                    `;

                }
            )
            .join("");


    // =================================================
    // ACTUALIZAR RESUMEN
    // =================================================

    actualizarResumen(
        registrosFiltrados
    );

}


// =====================================================
// ACTUALIZAR RESUMEN
// =====================================================

function actualizarResumen(
    registros = registrosDobles
) {


    // =================================================
    // TOTAL EMPLEADOS
    // =================================================

    const totalEmpleados =
        document.getElementById(
            "totalEmpleados"
        );


    if (totalEmpleados) {

        totalEmpleados.textContent =
            registros.length;

    }


    // =================================================
    // TOTAL HORAS EXTRAS
    // =================================================

    const totalHorasExtras =
        document.getElementById(
            "totalHorasExtras"
        );


    if (totalHorasExtras) {

        const total =
            registros.reduce(
                function (
                    suma,
                    registro
                ) {

                    return suma +
                        convertirNumero(
                            registro.HORASEXTRAS
                        );

                },
                0
            );


        totalHorasExtras.textContent =
            formatearNumero(
                total
            );

    }


    // =================================================
    // TOTAL HORAS DOBLES
    // =================================================

    const totalHorasDobles =
        document.getElementById(
            "totalHorasDobles"
        );


    if (totalHorasDobles) {

        const total =
            registros.reduce(
                function (
                    suma,
                    registro
                ) {

                    return suma +
                        convertirNumero(
                            registro.HRSDOBLES
                        );

                },
                0
            );


        totalHorasDobles.textContent =
            formatearNumero(
                total
            );

    }


    // =================================================
    // TOTAL PAGADO
    // =================================================

    const totalPagoHoras =
        document.getElementById(
            "totalPagoHoras"
        );


    if (totalPagoHoras) {

        const total =
            registros.reduce(
                function (
                    suma,
                    registro
                ) {

                    return suma +
                        convertirNumero(
                            registro.TOTALEXTRASYDOBLES ??
                            registro.TOTALEXTRASDOBLES
                        );

                },
                0
            );


        totalPagoHoras.textContent =
            `Q ${formatearNumero(
                total
            )}`;

    }

}


// =====================================================
// EDITAR REGISTRO
// =====================================================

function manejarClickEditar(
    event
) {

    const boton =
        event.target.closest(
            ".btnEditarDobles"
        );


    if (!boton) {

        return;

    }


    const id =
        boton.dataset.id;


    console.log(
        "✏️ IDINGRESONO seleccionado:",
        id
    );


    const registro =
        registrosDobles.find(
            function (item) {

                return String(
                    item.IDINGRESONO
                ) === String(id);

            }
        );


    if (!registro) {

        console.error(
            "❌ No se encontró el registro:",
            id
        );

        return;

    }


    console.log(
        "📦 Registro seleccionado:",
        registro
    );


    // =================================================
    // MODAL
    // =================================================

    const modal =
        document.getElementById(
            "modalDobles"
        );


    if (!modal) {

        console.warn(
            "⚠️ No se encontró #modalDobles."
        );

        return;

    }


    // =================================================
    // ID INGRESO
    // =================================================

    const idEmpleado =
        document.getElementById(
            "idEmpleado"
        );


    if (idEmpleado) {

        idEmpleado.value =
            registro.IDINGRESONO ??
            "";

    }


    // =================================================
    // MOSTRAR ID
    // =================================================

    const mostrarIdEmpleado =
        document.getElementById(
            "mostrarIdEmpleado"
        );


    if (mostrarIdEmpleado) {

        mostrarIdEmpleado.value =
            registro.IDINGRESONO ??
            "";

    }


    // =================================================
    // NOMBRE
    // =================================================

    const nombreEmpleado =
        document.getElementById(
            "nombreEmpleado"
        );


    if (nombreEmpleado) {

        nombreEmpleado.value =
            registro.NOMBREEMPLEADO ??
            "";

    }


    // =================================================
    // DPI
    // =================================================

    const dpiEmpleado =
        document.getElementById(
            "dpiEmpleado"
        );


    if (dpiEmpleado) {

        dpiEmpleado.value =
            registro.DPI ??
            "";

    }


    // =================================================
    // PUESTO
    // =================================================

    const puestoEmpleado =
        document.getElementById(
            "puestoEmpleado"
        );


    if (puestoEmpleado) {

        puestoEmpleado.value =
            registro.NOMBREPUESTO ??
            registro.PUESTO ??
            "";

    }


    // =================================================
    // DIRECCIÓN
    // =================================================

    const direccionEmpleado =
        document.getElementById(
            "direccionEmpleado"
        );


    if (direccionEmpleado) {

        direccionEmpleado.value =
            registro.DIRECCION ??
            "";

    }


    // =================================================
    // SALARIO BASE
    // =================================================

    const salarioBase =
        document.getElementById(
            "salarioBase"
        );


    if (salarioBase) {

        salarioBase.value =
            convertirNumero(
                registro.SALARIOBASE
            );

    }


    // =================================================
    // DÍAS LABORALES
    // =================================================

    const diasLaborales =
        document.getElementById(
            "diasLaborales"
        );


    if (diasLaborales) {

        diasLaborales.value =
            convertirNumero(
                registro.CANTIDADLABORALES ??
                registro.DIASLABORALES ??
                registro["DIAS LABORALES"]
            );

    }


    // =================================================
    // HORAS ESTABLECIDAS
    // =================================================

    const horasEstablecidas =
        document.getElementById(
            "horasEstablecidas"
        );


    if (horasEstablecidas) {

        horasEstablecidas.value =
            convertirNumero(
                registro.HORASESTABLECIDAS
            );

    }


    // =================================================
    // HORAS EXTRAS
    // =================================================

    const horasExtras =
        document.getElementById(
            "horasExtras"
        );


    if (horasExtras) {

        horasExtras.value =
            convertirNumero(
                registro.HORASEXTRAS
            );

    }


    // =================================================
    // PAGO ORDINARIO HORA EXTRA
    // =================================================

    const pagoOrdinariaHrExtra =
        document.getElementById(
            "pagoOrdinariaHrExtra"
        );


    if (pagoOrdinariaHrExtra) {

        pagoOrdinariaHrExtra.value =
            convertirNumero(
                registro.PAGOORDINARIAHREXTRA
            );

    }


    // =================================================
    // PAGO HORA EXTRA
    // =================================================

    const pagoExtra =
        document.getElementById(
            "pagoExtra"
        );


    if (pagoExtra) {

        pagoExtra.value =
            convertirNumero(
                registro.PAGOEXTRA
            );

    }


    // =================================================
    // TOTAL HORAS EXTRAS
    // =================================================

    const totalExtraPagado =
        document.getElementById(
            "totalExtraPagado"
        );


    if (totalExtraPagado) {

        totalExtraPagado.value =
            convertirNumero(
                registro.TOTALEXTRAPAGADO
            );

    }


    // =================================================
    // HORAS DOBLES
    // =================================================

    const hrsDobles =
        document.getElementById(
            "hrsDobles"
        );


    if (hrsDobles) {

        const horasDobles =
            convertirNumero(
                registro.HRSDOBLES
            );


        hrsDobles.value =
            horasDobles > 0
                ? horasDobles
                : 2;

    }


    // =================================================
    // PAGO HORA DOBLE
    // =================================================

    const pagoHrsDoble =
        document.getElementById(
            "pagoHrsDoble"
        );


    if (pagoHrsDoble) {

        pagoHrsDoble.value =
            convertirNumero(
                registro.PAGOHRSDOBLE
            );

    }


    // =================================================
    // TOTAL HORAS DOBLES
    // =================================================

    const totalHrsDobles =
        document.getElementById(
            "totalHrsDobles"
        );


    if (totalHrsDobles) {

        totalHrsDobles.value =
            convertirNumero(
                registro.TOTALHRSDOBLES ??
                registro.TOTALHORASDOBLES
            );

    }


    // =================================================
    // RESUMEN HORAS EXTRAS
    // =================================================

    const resumenHorasExtras =
        document.getElementById(
            "resumenHorasExtras"
        );


    if (resumenHorasExtras) {

        resumenHorasExtras.textContent =
            `Q ${formatearNumero(
                registro.TOTALEXTRAPAGADO
            )}`;

    }


    // =================================================
    // RESUMEN HORAS DOBLES
    // =================================================

    const resumenHorasDobles =
        document.getElementById(
            "resumenHorasDobles"
        );


    if (resumenHorasDobles) {

        resumenHorasDobles.textContent =
            `Q ${formatearNumero(
                registro.TOTALHRSDOBLES ??
                registro.TOTALHORASDOBLES
            )}`;

    }


    // =================================================
    // RESUMEN TOTAL
    // =================================================

    const resumenTotal =
        document.getElementById(
            "resumenTotal"
        );


    if (resumenTotal) {

        resumenTotal.textContent =
            `Q ${formatearNumero(
                registro.TOTALEXTRASYDOBLES ??
                registro.TOTALEXTRASDOBLES
            )}`;

    }


    // =================================================
    // ESTADO
    // =================================================

    const estadoDobles =
        document.getElementById(
            "estadoDobles"
        );


    if (estadoDobles) {

        const estado =
            String(
                registro.ESTADO ?? "A"
            )
            .trim()
            .toUpperCase();


        estadoDobles.value =
            estado === "D"
                ? "I"
                : "A";

    }


    // =================================================
    // FECHA DE INGRESO
    // =================================================

    const fechaIngreso =
        document.getElementById(
            "fechaIngreso"
        );


    if (fechaIngreso) {

        fechaIngreso.value =
            convertirFechaInput(
                registro.FECHAINGRESO
            );

    }


    // =================================================
    // MOSTRAR MODAL
    // =================================================

    if (
        typeof bootstrap !==
        "undefined"
    ) {

        const instancia =
            bootstrap.Modal.getOrCreateInstance(
                modal
            );


        instancia.show();

    }


    // =================================================
    // CALCULAR AUTOMÁTICAMENTE
    // =================================================

    calcularDoblesAutomaticamente();

}


// =====================================================
// GUARDAR HORAS DOBLES
//
// Ruta:
// PUT /dobles/actualizar
//
// Procedimiento:
// SP_INGRESONOMINA_HRSEXTRADOBLES_U
// =====================================================

async function guardarDobles() {

    // =================================================
    // EVITAR DOBLE CLIC
    // =================================================

    if (guardandoDobles) {

        console.warn(
            "⚠️ Ya existe una actualización en proceso."
        );

        return;

    }


    // =================================================
    // OBTENER IDINGRESONO
    // =================================================

    const idEmpleado =
        document.getElementById(
            "idEmpleado"
        );


    const mostrarIdEmpleado =
        document.getElementById(
            "mostrarIdEmpleado"
        );


    const idIngreso =
        idEmpleado?.value ||
        mostrarIdEmpleado?.value ||
        "";


    // =================================================
    // VALIDAR ID
    // =================================================

    if (!idIngreso) {

        alert(
            "Debe seleccionar un registro antes de guardar."
        );

        return;

    }


    // =================================================
    // OBTENER CAMPOS
    // =================================================

    const hrsDobles =
        document.getElementById(
            "hrsDobles"
        );


    const pagoHrsDoble =
        document.getElementById(
            "pagoHrsDoble"
        );


    const totalHrsDobles =
        document.getElementById(
            "totalHrsDobles"
        );


    const totalExtraPagado =
        document.getElementById(
            "totalExtraPagado"
        );


    const estadoDobles =
        document.getElementById(
            "estadoDobles"
        );


    // =================================================
    // VALIDAR CAMPOS
    // =================================================

    if (
        !hrsDobles ||
        !pagoHrsDoble ||
        !totalHrsDobles ||
        !totalExtraPagado
    ) {

        console.error(
            "❌ Faltan campos necesarios en el modal."
        );

        alert(
            "No se encontraron todos los campos necesarios para guardar."
        );

        return;

    }


    // =================================================
    // CALCULAR ANTES DE GUARDAR
    // =================================================

    calcularDoblesAutomaticamente();


    // =================================================
    // OBTENER VALORES ACTUALIZADOS
    // =================================================

    const valorHorasDobles =
        convertirNumero(
            hrsDobles.value
        );


    const valorPagoHoraDoble =
        convertirNumero(
            pagoHrsDoble.value
        );


    const valorTotalHorasDobles =
        convertirNumero(
            totalHrsDobles.value
        );


    const valorTotalExtra =
        convertirNumero(
            totalExtraPagado.value
        );


    // =================================================
    // TOTAL EXTRAS + DOBLES
    // =================================================

    const valorTotalExtrasDobles =
        valorTotalExtra +
        valorTotalHorasDobles;


    // =================================================
    // ESTADO
    // =================================================

    const valorEstado =
        estadoDobles
            ? (
                String(
                    estadoDobles.value ||
                    "A"
                )
                .trim()
                .toUpperCase()
            )
            : "A";


    // =================================================
    // DATOS A ENVIAR
    // =================================================

    const datos = {

        IDINGRESONO:
            Number(idIngreso),

        HRSDOBLES:
            valorHorasDobles,

        PAGOHRSDOBLE:
            valorPagoHoraDoble,

        TOTALHORASDOBLES:
            valorTotalHorasDobles,

        TOTALEXTRASDOBLES:
            valorTotalExtrasDobles,

        ESTADO:
            valorEstado

    };


    console.log(
        "📤 ENVIANDO ACTUALIZACIÓN DE DOBLES:",
        datos
    );


    // =================================================
    // ACTIVAR ESTADO GUARDANDO
    // =================================================

    guardandoDobles = true;


    // =================================================
    // BUSCAR BOTÓN
    // =================================================

    const botonGuardar =
        document.querySelector(
            "#btnGuardarDobles, #guardarDobles, #btnGuardar"
        );


    const textoOriginal =
        botonGuardar
            ? botonGuardar.innerHTML
            : "";


    if (botonGuardar) {

        botonGuardar.disabled =
            true;

        botonGuardar.innerHTML = `

            <span
                class="spinner-border spinner-border-sm me-1"
                role="status"
            ></span>

            Guardando...

        `;

    }


    try {

        // =================================================
        // ENVIAR AL SERVIDOR
        // =================================================

        const respuesta =
            await fetch(
                "/dobles/actualizar",
                {

                    method:
                        "PUT",

                    headers: {

                        "Content-Type":
                            "application/json",

                        "Accept":
                            "application/json"

                    },

                    body:
                        JSON.stringify(
                            datos
                        )

                }
            );


        // =================================================
        // OBTENER RESPUESTA
        // =================================================

        const resultado =
            await respuesta.json();


        console.log(
            "📥 RESPUESTA ACTUALIZACIÓN:",
            resultado
        );


        // =================================================
        // VALIDAR RESPUESTA
        // =================================================

        if (
            !respuesta.ok ||
            !resultado ||
            resultado.ok !== true
        ) {

            throw new Error(
                resultado?.mensaje ||
                resultado?.error ||
                `HTTP ${respuesta.status}`
            );

        }


        // =================================================
        // ACTUALIZAR REGISTRO LOCAL
        // =================================================

        const indice =
            registrosDobles.findIndex(
                function (registro) {

                    return String(
                        registro.IDINGRESONO
                    ) === String(
                        idIngreso
                    );

                }
            );


        if (indice !== -1) {

            registrosDobles[indice] = {

                ...registrosDobles[indice],

                HRSDOBLES:
                    valorHorasDobles,

                PAGOHRSDOBLE:
                    valorPagoHoraDoble,

                TOTALHRSDOBLES:
                    valorTotalHorasDobles,

                TOTALHORASDOBLES:
                    valorTotalHorasDobles,

                TOTALEXTRASYDOBLES:
                    valorTotalExtrasDobles,

                TOTALEXTRASDOBLES:
                    valorTotalExtrasDobles,

                ESTADO:
                    valorEstado

            };

        }


        // =================================================
        // ACTUALIZAR TABLA
        // =================================================

        const buscarHoraExtra =
            document.getElementById(
                "buscarHoraExtra"
            );


        renderizarTablaDobles(
            buscarHoraExtra
                ? buscarHoraExtra.value
                : ""
        );


        // =================================================
        // MENSAJE
        // =================================================

        console.log(
            "✅ Horas dobles guardadas correctamente."
        );


        alert(
            "Horas dobles actualizadas correctamente."
        );


        // =================================================
        // CERRAR MODAL
        // =================================================

        const modal =
            document.getElementById(
                "modalDobles"
            );


        if (
            modal &&
            typeof bootstrap !==
            "undefined"
        ) {

            const instancia =
                bootstrap.Modal.getInstance(
                    modal
                );


            if (instancia) {

                instancia.hide();

            }

        }


    } catch (error) {

        console.error(
            "❌ ERROR AL GUARDAR HORAS DOBLES:",
            error
        );


        alert(
            "Error al guardar las horas dobles:\n\n" +
            error.message
        );


    } finally {

        // =================================================
        // RESTAURAR ESTADO
        // =================================================

        guardandoDobles =
            false;


        if (botonGuardar) {

            botonGuardar.disabled =
                false;

            botonGuardar.innerHTML =
                textoOriginal;

        }

    }

}


// =====================================================
// CALCULAR DOBLES AUTOMÁTICAMENTE
// =====================================================

function calcularDoblesAutomaticamente() {

    // =================================================
    // INPUT HORAS DOBLES
    // =================================================

    const hrsDobles =
        document.getElementById(
            "hrsDobles"
        );


    // =================================================
    // INPUT PAGO HORA EXTRA
    // =================================================

    const pagoExtra =
        document.getElementById(
            "pagoExtra"
        );


    // =================================================
    // INPUT PAGO HORA DOBLE
    // =================================================

    const pagoHrsDoble =
        document.getElementById(
            "pagoHrsDoble"
        );


    // =================================================
    // INPUT TOTAL HORAS DOBLES
    // =================================================

    const totalHrsDobles =
        document.getElementById(
            "totalHrsDobles"
        );


    // =================================================
    // INPUT TOTAL HORAS EXTRAS
    // =================================================

    const totalExtraPagado =
        document.getElementById(
            "totalExtraPagado"
        );


    // =================================================
    // VALIDAR INPUTS
    // =================================================

    if (
        !hrsDobles ||
        !pagoExtra ||
        !pagoHrsDoble ||
        !totalHrsDobles ||
        !totalExtraPagado
    ) {

        console.warn(
            "⚠️ No se encontraron todos los campos para calcular las horas dobles."
        );

        return;

    }


    // =================================================
    // OBTENER VALORES
    // =================================================

    let horasDobles =
        convertirNumero(
            hrsDobles.value
        );


    const valorPagoExtra =
        convertirNumero(
            pagoExtra.value
        );


    const valorTotalExtra =
        convertirNumero(
            totalExtraPagado.value
        );


    // =================================================
    // SI HORAS DOBLES ES 0
    // USAR 2 POR DEFECTO
    // =================================================

    if (
        horasDobles <= 0
    ) {

        horasDobles = 2;

        hrsDobles.value =
            horasDobles;

    }


    // =================================================
    // CALCULAR PAGO HORA DOBLE
    // =================================================

    const valorPagoHoraDoble =
        valorPagoExtra * 2;


    pagoHrsDoble.value =
        valorPagoHoraDoble
            .toFixed(2);


    // =================================================
    // CALCULAR TOTAL HORAS DOBLES
    // =================================================

    const valorTotalDobles =
        horasDobles *
        valorPagoHoraDoble;


    totalHrsDobles.value =
        valorTotalDobles
            .toFixed(2);


    // =================================================
    // CALCULAR TOTAL EXTRAS + DOBLES
    // =================================================

    const valorTotalGeneral =
        valorTotalExtra +
        valorTotalDobles;


    // =================================================
    // RESUMEN HORAS EXTRAS
    // =================================================

    const resumenHorasExtras =
        document.getElementById(
            "resumenHorasExtras"
        );


    if (resumenHorasExtras) {

        resumenHorasExtras.textContent =
            `Q ${formatearNumero(
                valorTotalExtra
            )}`;

    }


    // =================================================
    // RESUMEN HORAS DOBLES
    // =================================================

    const resumenHorasDobles =
        document.getElementById(
            "resumenHorasDobles"
        );


    if (resumenHorasDobles) {

        resumenHorasDobles.textContent =
            `Q ${formatearNumero(
                valorTotalDobles
            )}`;

    }


    // =================================================
    // RESUMEN TOTAL
    // =================================================

    const resumenTotal =
        document.getElementById(
            "resumenTotal"
        );


    if (resumenTotal) {

        resumenTotal.textContent =
            `Q ${formatearNumero(
                valorTotalGeneral
            )}`;

    }


    // =================================================
    // CONSOLA
    // =================================================

    console.log(
        "🧮 CÁLCULO AUTOMÁTICO DOBLES:",
        {

            horasDobles:
                horasDobles,

            pagoHoraExtra:
                valorPagoExtra,

            pagoHoraDoble:
                valorPagoHoraDoble,

            totalHorasExtra:
                valorTotalExtra,

            totalHorasDobles:
                valorTotalDobles,

            totalExtrasDobles:
                valorTotalGeneral

        }
    );

}


// =====================================================
// OBTENER INICIALES
// =====================================================

function obtenerIniciales(
    nombre
) {

    const texto =
        String(
            nombre ?? ""
        )
        .trim();


    if (!texto) {

        return "EM";

    }


    const partes =
        texto
            .split(/\s+/)
            .filter(
                parte => parte.length > 0
            );


    if (partes.length === 1) {

        return partes[0]
            .substring(0, 2)
            .toUpperCase();

    }


    return (
        partes[0].charAt(0) +
        partes[1].charAt(0)
    )
    .toUpperCase();

}


// =====================================================
// ESTADO
// =====================================================

function obtenerEstado(
    estado
) {

    const valor =
        String(
            estado ?? ""
        )
        .trim()
        .toUpperCase();


    if (valor === "A") {

        return `

            <span
                class="badge-activo"
            >

                ACTIVO

            </span>

        `;

    }


    if (
        valor === "D" ||
        valor === "I"
    ) {

        return `

            <span
                class="badge-inactivo"
            >

                INACTIVO

            </span>

        `;

    }


    return `

        <span
            class="badge bg-secondary"
        >

            ${escapeHtml(
                valor ||
                "SIN ESTADO"
            )}

        </span>

    `;

}


// =====================================================
// FORMATEAR NÚMERO
// =====================================================

function formatearNumero(
    valor
) {

    const numero =
        convertirNumero(
            valor
        );


    return numero.toFixed(2);

}


// =====================================================
// CONVERTIR NÚMERO
// =====================================================

function convertirNumero(
    valor
) {

    if (
        valor === null ||
        valor === undefined ||
        valor === ""
    ) {

        return 0;

    }


    const numero =
        Number(valor);


    if (
        Number.isFinite(numero)
    ) {

        return numero;

    }


    return 0;

}


// =====================================================
// CONVERTIR FECHA PARA INPUT DATE
// =====================================================

function convertirFechaInput(
    fecha
) {

    if (
        !fecha
    ) {

        return "";

    }


    const texto =
        String(fecha);


    if (
        /^\d{4}-\d{2}-\d{2}$/.test(
            texto
        )
    ) {

        return texto;

    }


    const fechaObjeto =
        new Date(fecha);


    if (
        Number.isNaN(
            fechaObjeto.getTime()
        )
    ) {

        return "";

    }


    const año =
        fechaObjeto.getFullYear();


    const mes =
        String(
            fechaObjeto.getMonth() + 1
        )
        .padStart(
            2,
            "0"
        );


    const dia =
        String(
            fechaObjeto.getDate()
        )
        .padStart(
            2,
            "0"
        );


    return `${año}-${mes}-${dia}`;

}


// =====================================================
// ESCAPAR HTML
// =====================================================

function escapeHtml(
    valor
) {

    return String(
        valor ?? ""
    )
    .replace(
        /&/g,
        "&amp;"
    )
    .replace(
        /</g,
        "&lt;"
    )
    .replace(
        />/g,
        "&gt;"
    )
    .replace(
        /"/g,
        "&quot;"
    )
    .replace(
        /'/g,
        "&#039;"
    );

}